function FormattedTextFilter($sce) {
  'ngInject';
  return function (input) {
    return $sce.trustAsHtml(input);
  };
}
export default {
  name: 'FormattedTextFilter',
  fn: FormattedTextFilter
};